
// Vue
import {Options, Vue} from "vue-class-component";

// Store
import store from "@/store/index";

// Models
import {AppCommonUser} from "@/models/app/common/User";
import {AppCommonTrainingCategory} from "@/models/app/common/training-category";
import {ResponseIndex} from "@/models/response";

// Components
import {
  ElRow,
  ElCol,
} from "element-plus";
import AdministratorNavigationVue from "@/components/administrator/navigation.vue";
import AdministratorTrainingsNavigationVue from "@/components/administrator/trainings/navigation.vue";
import AppAdministratorTrainingsRootFilterIndexVue from "@/views/app/administrator/trainings/root/filter/index.vue";
import AppAdministratorTrainingsRootListIndexVue from "@/views/app/administrator/trainings/root/list/index.vue";

// Services
import {getRequest} from "@/services/api/request";

@Options({
  components: {
    ElRow,
    ElCol,
    AdministratorNavigationVue,
    AdministratorTrainingsNavigationVue,
    AppAdministratorTrainingsRootFilterIndexVue,
    AppAdministratorTrainingsRootListIndexVue,
  },
})
export default class AppAdministratorTrainingsRootIndexVue extends Vue {
  isLoading: boolean | null = false;

  players: Array<AppCommonUser> = [];
  trainingCategories: Array<AppCommonTrainingCategory> = [];

  $refs!: {
    AppAdministratorTrainingsRootListIndexVue: any;
  };

  getTrainingsByFilter(formData: any): void {
    this.$refs.AppAdministratorTrainingsRootListIndexVue.getTrainings(formData);
  }

  async getPlayers(): Promise<void> {
    this.isLoading = true;
    await getRequest({
      uri: `/common/utility/organization-members`,
      formData: {
        organization_id: store.getters.getOrganizationMember.organization_id,
        role: "player",
      },
      isProtected: true,
    }).then((r: ResponseIndex) => {
      if (r.data) {
        this.players = r.data;
      }
    });
    this.isLoading = false;
  }

  async getTrainingCategories(): Promise<void> {
    this.isLoading = true;
    await getRequest({
      uri: `/common/utility/training-categories`,
      formData: {
        organization_id: store.getters.getOrganizationMember.organization_id,
      },
      isProtected: true,
    }).then((r: ResponseIndex) => {
      if (r.data) {
        this.trainingCategories = r.data;
      }
    });
    this.isLoading = false;
  }

  async created(): Promise<void> {
    await this.getPlayers();
    await this.getTrainingCategories();
  }
}
